<template>
  <form class="zpa-form no-fit" :class="classes" :id="id">
    <slot></slot>
    <zpa-row v-if="$slots.actions">
      <slot name="actions"></slot>
    </zpa-row>
  </form>
</template>

<script>
import _ from 'lodash'
import props from './form-props'

export default {
  name: 'zpaForm',

  data() {
    return {
      isForm: true,
      fields: [],
      groups: [],
      io: null,
    }
  },

  props: {
    ...props,

    size: {
      type: String,
      default: 'default',
    },

    id: String,

    inline: Boolean,
  },
  computed: {
    classes() {
      return { 'height-auto': this.autoHeight }
    },
  },
  provide() {
    return {
      form: this,
      group: null,
    }
  },

  methods: {
    flexDirection() {
      return 'row'
    },

    addField(field) {
      if (field && !this.fields.includes(field)) {
        this.fields.push(field)
      }
    },

    removeField(field) {
      const index = this.fields.indexOf(field)

      if (index > -1) {
        this.fields.splice(index, 1)
      }
    },

    addGroup(group, parent) {
      if (parent) {
        parent.groups.push(group)
      }

      this.groups.push(group)

      if (this.io) {
        this.io.observe(group.$el)
      }
    },

    removeGroup(group, parent) {
      if (parent) {
        const index = parent.groups.indexOf(group)
        parent.groups.splice(index, 1)
      }

      const index = this.groups.indexOf(group)
      this.groups.splice(index, 1)

      if (this.io) {
        this.io.unobserve(group.$el)
      }
    },

    async validate() {
      const result = await Promise.all(this.fields.map(f => {
        return f.validate()
      })).catch(e => {
        throw e
      })

      return result.every(r => !r)
    },

    reset() {
      this.fields.forEach(f => f.reset())
    },

    initIntersectionObserver() {
      if (typeof IntersectionObserver === 'undefined') return

      this.io = new IntersectionObserver(this.onIntersectionObserver, {
        thresholds: [0, 0.25, 0.5, 1],
        root: this.$parent.$el,
      })

      this.groups.forEach(({ $el }) => this.io.observe($el))
    },

    onIntersectionObserver: _.throttle(function(entries) {
      // 更新entry信息
      entries.forEach(e => this.groups.forEach(g => g.setEntry(e)))

      const groups = this.groups.filter(g => (g.entry && g.entry.isIntersecting))
      // .sort((o1, o2) => {
      //   o1 = o1.entry
      //   o2 = o2.entry
      //   let result = 5
      //
      //   if (!o1.entry) return 9
      //
      //   if (o1.intersectionRatio > o2.intersectionRatio) {
      //     result--
      //   } else if (o1.intersectionRatio < o2.intersectionRatio) {
      //     result++
      //   }
      //
      //   if (o1.intersectionRect.top > o2.intersectionRect.top) {
      //     result--
      //   } else if (o1.intersectionRect.top < o2.intersectionRect.top) {
      //     result++
      //   }
      //
      //   return result
      // })

      this.$emit('on-scroll', groups)
    }, 100),
  },

  created() {
  },

  mounted() {
    this.initIntersectionObserver()
  },

  destroyed() {
  },
}
</script>

<style scoped lang="less">
  .zpa-form {
    width: 100%;
    max-width: 100%;
    background: #fff;
  }
</style>
